module.exports = __webpack_public_path__ + "img/cancel.0424aae9.svg";